(() => {
  // Public Site ID from the store's existing Klaviyo embed; never a private key.
  const siteId = 'XZzBgD';
  const lists = { US: 'QXwHXr', CA: 'RYUMEu', AU: 'VNHjBQ', UK: 'UtFJ4N', EU: 'UrEtWN', Global: 'TsFMWL' };
  const euCountries = new Set('AT BE BG HR CY CZ DK EE FI FR DE GR HU IE IT LV LT LU MT NL PL PT RO SK SI ES SE'.split(' '));

  function initialize(root) {
    root.querySelectorAll('[data-ac-newsletter]').forEach((form) => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const fieldset = form.querySelector('fieldset');
      const input = form.querySelector('input[type="email"]');
      const button = form.querySelector('button[type="submit"]');
      const message = form.querySelector('[role="status"]');
      const originalButton = button.innerHTML;
      fieldset.disabled = false;
      let pending = false;
      let complete = false;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (pending || complete || !form.reportValidity()) return;
        const email = input.value.trim();
        const country = (form.dataset.country || '').toUpperCase();
        const region = country === 'GB' ? 'UK' : euCountries.has(country) ? 'EU' : ['US', 'CA', 'AU'].includes(country) ? country : 'Global';
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Acemate footer newsletter',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    properties: {
                      ac_newsletter_source: 'footer',
                      ac_newsletter_country: country || 'Unknown',
                      ac_newsletter_region: region,
                      ac_newsletter_language: form.dataset.language || 'en'
                    },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: lists[region] } } }
          }
        };
        pending = true;
        fieldset.disabled = true;
        form.setAttribute('aria-busy', 'true');
        message.hidden = true;
        button.textContent = 'Subscribing…';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${siteId}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify(payload),
            signal: controller.signal,
            credentials: 'omit'
          });
          if (!response.ok) {
            const error = new Error('Subscription request failed');
            error.status = response.status;
            throw error;
          }
          complete = true;
          input.value = '';
          button.textContent = 'Thank you';
          message.textContent = 'Thanks for signing up! If you receive a confirmation email, please confirm your subscription.';
        } catch (error) {
          fieldset.disabled = false;
          button.innerHTML = originalButton;
          message.textContent = error.status === 429
            ? 'Please wait a moment, then try subscribing again.'
            : 'We couldn’t confirm your subscription. Please check your connection and try again.';
        } finally {
          clearTimeout(timeout);
          pending = false;
          form.removeAttribute('aria-busy');
          message.hidden = false;
        }
      });
    });
  }
  initialize(document);
  if (!window.acFooterNewsletterSectionListener) {
    window.acFooterNewsletterSectionListener = true;
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  }
})();
